import { Cookies } from 'react-cookie-consent';

// Określamy, którego ID GA używać w zależności od środowiska
const getGAMeasurementId = (): string | null => {
  const isProduction = process.env.NODE_ENV === 'production';
  
  if (isProduction) {
    return process.env.REACT_APP_GA_MEASUREMENT_ID_PRODUCTION || null;
  } else {
    return process.env.REACT_APP_GA_MEASUREMENT_ID_DEVELOPMENT || null;
  }
};

// Inicjalizacja Google Analytics
export const initializeGA = (): void => {
  const analyticsConsent = Cookies.get('cookieconsent_analytics') === 'true';
  const measurementId = getGAMeasurementId();

  
  if (!analyticsConsent || !measurementId) {
    return;
  }

  // Dodajemy skrypt Google Analytics (gtag.js)
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Inicjalizacja gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', measurementId, {
    send_page_view: false // Wyłączamy automatyczne śledzenie, będziemy śledzić ręcznie
  });
};

// Śledzenie zmiany strony
export const trackPageView = (path: string): void => {
  const analyticsConsent = Cookies.get('cookieconsent_analytics') === 'true';
  
  if (!analyticsConsent || !window.gtag) {
    return;
  }
  
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: document.title,
    page_location: window.location.href
  });
};

// Śledzenie zdarzeń
export const trackEvent = (
  eventName: string,
  eventParams: Record<string, any> = {}
): void => {
  const analyticsConsent = Cookies.get('cookieconsent_analytics') === 'true';
  
  if (!analyticsConsent || !window.gtag) {
    return;
  }
  
  window.gtag('event', eventName, eventParams);
};
